import React from 'react';
import { object } from 'prop-types';
import { userModuleTypes } from '../src/utils/misc';
import Users from './users';

const Shoppers = ({ session }) => <Users session={session} type={userModuleTypes[1]} />;

Shoppers.propTypes = {
    session: object
};

 export default Shoppers;
